import type { Messages } from "../types";

export const messages: Messages = {
  shared: {
    title: "Zákaznický účet Fielmann",
    tabs: {
      login: "Přihlášení",
      signup: "Registrace",
      ariaLabel: "Přihlášení a registrace",
    },
    languageSwitcher: {
      label: "Vyber jazyk",
    },
    password: {
      show: "Zobrazit heslo",
      hide: "Skrýt heslo",
    },
    header: {
      logoAriaLabel: "Fielmann",
    },
    footer: {
      ariaLabel: "Zápatí",
      customerService: "Zákaznický servis",
      legalNotice: "Impresum",
      dataProtection: "Ochrana osobních údajů",
    },
    loading: {
      ariaLabel: "Moment, prosím...",
      content: "Obsah se načítá.",
    },
  },
  login: {
    subtitle: "Přihlas se e-mailem a heslem.",
    form: {
      emailLabel: "E-mail *",
      passwordLabel: "Heslo *",
      forgotPassword: "Zapomenuté heslo?",
      submitButton: "Přihlásit se",
      credentialError: "E-mail a heslo se neshodují.",
      genericError: "Došlo k chybě. Zkus to prosím později znovu.",
    },
  },
  signup: {
    subtitle: {
      before: "Využij ",
      highlight: "výhody",
      after: " a vytvoř si zákaznický účet Fielmann.",
    },
    benefits: {
      popoverHeading: "Tvoje výhody:",
      closeLabel: "Zavřít",
      items: {
        orders:
          "Všechny objednávky Fielmann včetně jejich stavu na jednom místě.",
        visionValues: "Použij své naměřené hodnoty zraku při další objednávce.",
        appointments: "Rezervuj a spravuj své termíny.",
        reorders: "Další objednávky snadno vyřídíš online.",
      },
    },
    form: {
      firstNameLabel: "Jméno *",
      lastNameLabel: "Příjmení *",
      emailLabel: "E-mail *",
      passwordLabel: "Heslo *",
      passwordRepeatLabel: "Potvrdit heslo *",
      submitButton: "Zaregistrovat se",
      errorTitle: "Účet se nepodařilo vytvořit.",
      errorMessage: "Zkontroluj zadané údaje nebo to zkus později znovu.",
      genericError: "Došlo k chybě. Zkus to prosím později znovu.",
    },
    consents: {
      requiredError: "Potvrď prosím požadovaný souhlas.",
      unavailableError: "Došlo k chybě. Zkus to prosím později znovu.",
      required: {
        headline: "Souhlas se zákaznickým účtem",
        subline:
          "Abychom ti mohli zobrazit veškerý obsah ve tvém zákaznickém účtu (např. nákupy nebo termíny), potřebujeme tvůj souhlas.",
      },
      optional: {
        headline: "Chceš dostávat personalizovanou reklamu?",
        subline:
          "Máš na výběr: se souhlasem budeš dostávat nabídky a informace na míru. Bez souhlasu používáš svůj zákaznický účet bez personalizované reklamy.",
      },
    },
  },
  emailVerification: {
    subtitle: "Nemůžeš se přihlásit?",
    alertTitle: "Nejdřív potvrď svou e-mailovou adresu.",
    alertBody:
      "Nejdřív prosím potvrď svou e-mailovou adresu. Tím aktivuješ svůj účet Fielmann.",
    alertSpamHint: "E-mail nemůžeš najít? Podívej se také do složky se spamem.",
    resendButton: "Znovu odeslat e-mail",
    backToLogin: "Zpět k přihlášení",
  },
  setPassword: {
    subtitle: "Nyní si můžeš nastavit heslo.",
    emailLabel: "E-mail *",
    passwordLabel: "Heslo *",
    passwordRepeatLabel: "Potvrdit heslo *",
    submitButton: "Uložit heslo",
    backToLogin: "K přihlášení",
    successTitle: "Tvoje heslo bylo úspěšně uloženo.",
    successBody: "Nyní se můžeš přihlásit.",
  },
  toasts: {
    missingRequiredFields:
      "Pro pokračování prosím vyplň všechna zbývající povinná pole.",
  },
  validation: {
    passwordRequired: "Zadej prosím heslo.",
    passwordRepeatRequired: "Zadej prosím heslo znovu.",
    firstNameTooLong: "Křestní jméno nesmí být delší než 30 znaků.",
    firstNameRequired: "Zadej prosím jméno.",
    firstNameInvalidFormat: "Zadej prosím platné křestní jméno.",
    lastNameTooLong: "Příjmení nesmí být delší než 30 znaků.",
    lastNameRequired: "Zadej prosím příjmení.",
    lastNameInvalidFormat: "Zadej prosím platné příjmení.",
    emailTooLong: "Tato e-mailová adresa je příliš dlouhá.",
    emailRequired: "Zadej prosím e-mailovou adresu.",
    emailInvalidFormat: "Zadej prosím platnou e-mailovou adresu.",
    passwordMatchesEmail: "Heslo nesmí být stejné jako e-mailová adresa.",
    passwordMismatch: "Hesla se neshodují.",
  },
  passwordRequirements: {
    minimumLength: "Alespoň 10 znaků",
    mixedCase: "Alespoň jedno velké a jedno malé písmeno",
    hasNumber: "Alespoň jedno číslo",
    specialCharactersAllowed: "Speciální znaky jsou povoleny (např. !@#$%^&*)",
  },
};
